import { Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts'
import { LoginGate } from './LoginGate'

/**
 * Guards every member page in one place.
 *
 * Until now there was no route guard at all: each of the 31 pages rendered a
 * Layout, and Layout refused to draw anything when signed out. That worked,
 * but it meant no page could ever be public - which is why the site has never
 * had a front door.
 *
 * Wrapping the member routes in this instead keeps them exactly as protected
 * while leaving room for routes that are not.
 */
export function RequireAuth() {
  const { user, loading } = useAuth()

  // Don't flash the login screen at a member whose session is still loading
  if (loading) {
    return (
      <div className="min-h-screen bg-raven-darker flex items-center justify-center">
        <div className="text-gray-400">Loading...</div>
      </div>
    )
  }

  if (!user) return <LoginGate />

  return <Outlet />
}
